// extracted by mini-css-extract-plugin
module.exports = {"productCard":"VIP_style__productCard"};